<div class="row p-4 text-center">
  <div class="col">
      <h5>{{ message }}</h5>
  </div>
  <div class="row">
    <div class="col pt-4">
      <div class="form-group">
        <button
          type="button"
          class="btn btn-danger"
          (click)="change(true)"
        >
          Подтвердить
        </button>
      </div>
    </div>
    <div class="col pt-4">
      <button
        type="button"
        class="btn btn-light"
        (click)="change(false)"
      >
        Отмена
      </button>
    </div>
  </div>
</div>

